import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Sharing from '../../../common/sharing/Sharing';

class CacaAoTesouroModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showShareButtons: false,
        };
    }

    _toggleShareButtons = () => {
        this.setState((prevState) => ({
            showShareButtons: !prevState.showShareButtons,
        }));
    }

    _closeModal = () => {
        // hide modal
        this.props.handleModal(false);

        // NOTE: as I added the share component instead of only facebook, there is no way of knowing if the user shared the hunt or not.
        // It also seamed wrongly implemented...
    }

    render() {
        const prizeInfo = this.props.prizeInfo;
        const prizeName = prizeInfo?.tx_nome;
        const shareTitle = 'Acabei de encontrar um baú na Antena 1 e ganhei um prêmio!!!!';

        return (
            <div className="modal-hunt">
                <div className="modal-content-hunt">
                    <div className="content-block">
                        <p>
                            Parabéns!!!
                            {' '}
                            <br />
                            Você acaba de achar um baú do tesouro e ganhou um(a)
                            {' '}
                            <br />
                            <b>
                                <span className="text-uppercase">
                                    {prizeName}
                                </span>
                            </b>
                            <br />
                            Você irá receber um e-mail com instruções para resgatar seu prêmio.
                            {' '}
                            <br />
                            Agora falta apenas compartilhar em sua rede social, e você poderá
                            voltar a procurar outro baú do tesouro.
                        </p>
                        <div className="button-share-container">
                            {
                                this.state.showShareButtons ?
                                    [
                                        <Sharing
                                            key="sharing-buttons"
                                            styleEffect="pulseIcon"
                                            path="caca-ao-tesouro"
                                            shareButtonsTo={['facebook', 'twitter', 'whatsapp']}
                                            iconSize={28}
                                            widthBlockIcon={35}
                                            facebook={{ quote: shareTitle, hashtag: '#Antena1' }}
                                            twitter={{ title: shareTitle, hashtags: ['CaçaAoTesouro', 'Antena1'] }}
                                            whatsapp={{ title: shareTitle }}
                                        />,
                                        <Button key="close-button" title="Fechar" onClick={this._closeModal} className="modal-button-close">
                                            fechar
                                        </Button>,
                                    ]
                                    :
                                    <Button title="Mostrar opções de compartilhar" onClick={this._toggleShareButtons} className="modal-button-ok">
                                        ok, entendi
                                    </Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CacaAoTesouroModal.propTypes = exact({
    handleModal: PropTypes.func,
    prizeInfo: PropTypes.object,
});


export default CacaAoTesouroModal;
